import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from './store/alert.module';
import { users } from './store/users.module';
import { heros } from './store/heros.module';
import { keyValues } from './store/keyValues.module';
import { members } from './store/members.module';
import { messages } from './store/messages.module';
import { prizes } from './store/prizes.module';
import { settings } from './store/settings.module';
import { staticInfos } from './store/staticInfos.module';
import { wines } from './store/wines.module';
import { experiences } from './store/experiences.module';
import { guides } from './store/guides.module';
import { reservations } from './store/reservations.module';
import { experienceAvailabilities } from './store/experienceAvailabilities.module';
import { availabilityIntervals } from './store/availabilityIntervals.module';
import { satisfactionQuestions } from './store/satisfactionQuestions.module';
import { satisfactionFormAnswers } from './store/satisfactionFormAnswers.module';
import { vouchers } from './store/vouchers.module';

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  modules: {alert,users,heros,keyValues,members,messages,prizes,settings,staticInfos,wines,experiences,guides,reservations,experienceAvailabilities,availabilityIntervals,satisfactionQuestions,satisfactionFormAnswers,vouchers}
});